// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"5fdc225d","597":"8e4dc0cb","871":"3d839bce"}[chunkId] + ".chunk.css";
};